<template>
  <div>

    <div class="head">
      <p class="title">{{ $t('pages.announcements.title') }}</p>
      <p>{{ $t('pages.announcements.description') }}</p>
    </div>

    <div class="announcements-container">
    <div
      v-for="announcement in announcements"
      :key="announcement.announcement_id"
      :class="['announcement-card', announcement.type]"
    >
      <div class="announcement-header">
        <img
          v-if="announcement.is_important"
          src="@/assets/important.svg"
          :alt="$t('pages.announcements.important_alt')"
          class="important-icon"
        />
        <span class="type"> {{ announcement.type }}</span>
        <span class="create-time">{{ formatDateTime(announcement.created_at) }}</span>
      </div>

      <div class="announcement-content">
        <p v-if="announcement.services" class="services">
          <b>{{ $t('pages.announcements.services_label') }}</b> {{ announcement.services }}
        </p>
        <p v-if="announcement.start_time" class="start">
          <b>{{ $t('pages.announcements.start_label') }}</b> {{ formatDateTime(announcement.start_time) }}
        </p>
        <p v-if="announcement.end_time" class="end">
          <b>{{ $t('pages.announcements.end_label') }}</b> {{ formatDateTime(announcement.end_time) }}
        </p>
        <p v-if="announcement.duration" class="duration">
          <b>{{ $t('pages.announcements.duration_label') }}</b> {{ announcement.duration }} {{ $t('pages.announcements.minutes') }}
        </p>
        <p v-if="announcement.headers" class="headers">
          <b>{{ $t('pages.announcements.headers_label') }}</b> {{ announcement.headers }}
        </p>
        <p v-if="announcement.details" class="details">
          <b>{{ $t('pages.announcements.details_label') }}</b> <br />
          <span v-html="announcement.details"></span>
        </p>
        <p
          v-if="announcement.status"
          :class="['status', getStatusColor(announcement.status)]"
        >
          <b>{{ $t('pages.announcements.status_label') }}</b> {{ translateStatus(announcement.status) }}
        </p>
        <p v-if="announcement.completed_note" class="completed-note">
          <b>{{ $t('pages.announcements.completed_note_label') }}</b> {{ announcement.completed_note }}
        </p>
      </div>
    </div>
  </div>

  </div>

</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      announcements: [],
    };
  },
  async mounted() {
    await this.fetchAnnouncements();
  },
  methods: {
    async fetchAnnouncements() {
      try {
        const response = await axios.get("/auth/announcements");
        if (response.data) {
          this.announcements = response.data;
        }
      } catch (error) {
        console.error("Duyurular alınırken hata oluştu:", error);
      }
    },
    formatDateTime(dateString) {
      if (!dateString) return "";
      const date = new Date(dateString);
      const locale = this.$i18n && this.$i18n.locale === 'en' ? 'en-US' : 'tr-TR';
      return date.toLocaleString(locale, {
        year: "numeric",
        month: "long",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      });
    },
    getStatusColor(status) {
      if (status === "Tamamlandı" || status === "Completed") return "status-completed";
      if (status === "Devam Ediyor" || status === "In Progress") return "status-in-progress";
      if (status === "Yaklaşan" || status === "Upcoming") return "status-upcoming";
      if (status === "İptal Edildi" || status === "Cancelled") return "status-cancelled";
      return "";
    },
    translateStatus(status) {
      const keyMap = {
        "Upcoming": "pages.announcements.status.upcoming",
        "Yaklaşan": "pages.announcements.status.upcoming",
        "In Progress": "pages.announcements.status.in_progress",
        "Devam Ediyor": "pages.announcements.status.in_progress",
        "Completed": "pages.announcements.status.completed",
        "Tamamlandı": "pages.announcements.status.completed",
        "Cancelled": "pages.announcements.status.cancelled",
        "İptal Edildi": "pages.announcements.status.cancelled",
      };
      return keyMap[status] ? this.$t(keyMap[status]) : status;
    },
  },
};
</script> 
  

  <style scoped>

  .head {
    margin-top: 10em;
    text-align: center;
  }
  .title {
     font-size: 1.8em;
     font-weight: 300; 
     margin-bottom: 0;
   } 
  .announcements-container {
    display: flex;
    flex-wrap: wrap;
    gap: 0.5em;
    justify-content: space-around;
    padding: 1em 0 10em 0;
  }
  
  .announcement-card {
    background-color: #070707;
    padding: 1rem;
    border: none;
    border-radius: 8px;
    width:49%;
    box-sizing: border-box;
    transition: background-color 0.4s ease;
  }
  
  .announcement-card:hover {
    background-color: #000;
  }
  .announcement-header {
    display: flex;
    margin-bottom: 1rem;
    align-items: center;
  }
  
  .type {
    font-weight: 600;
    font-size: 1rem;
    color: #187774; 
  }
  .create-time { 
    margin-left: 5px;
    font-size: 0.8em;
  }
  
  .announcement-content p {
    margin: 10px 0;
  }
  
  .details span {
    white-space: pre-wrap;
  }
  
  .status {
    font-weight: bold;
  }
  
  .status-completed {
    color: #127750;
  }
  
  .status-in-progress {
    color: #007999;
  }
  
  .status-upcoming {
    color: #917e5c;
  }
  .status-cancelled {
    color: #953342;
  }
  .completed-note { 
    color: #3e4f56;
  }
  .important-icon {
     width: 24px; 
     height: 24px;
     margin-right: 5px; 
   }
  @media (max-width: 768px) {
    .announcements-container {
      flex-direction: column;
    }
  
    .announcement-card {
      width: 100%;
    }
  }
  </style>